export default "__VITE_ASSET__88906235__"